<template>
  <div class="relative">
    <slot />
    <div
      v-if="show"
      class="absolute right-1 top-1 w-2 h-2 rounded-full"
      :class="{
        'bg-nami-comi-blue': type === 'primary',
      }"
    ></div>
  </div>
</template>

<script setup lang="ts">
const { type = "primary", show = false } = defineProps<{
  show?: boolean;
  type?: "primary";
}>();
</script>
